import { render, staticRenderFns } from "./AnaliticalManaged.vue?vue&type=template&id=18b58b67&scoped=true&"
import script from "./AnaliticalManaged.vue?vue&type=script&lang=js&"
export * from "./AnaliticalManaged.vue?vue&type=script&lang=js&"
import style0 from "./AnaliticalManaged.vue?vue&type=style&index=0&id=18b58b67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b58b67",
  null
  
)

export default component.exports